import {
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SimpleAlert from "../../display/SimpleAlert";


export default function FileUploadEditing({ file, index, categories }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Stack
      m={1}
      spacing={1}
      justifyContent={"space-between"}
      direction={"row"}
      alignItems={"center"}
      sx={{ width: "100%" }}
    >
      <Typography>{index + 1}</Typography>

      {/* Title Field */}
      <Controller
        name={`files[${index}].title`}
        control={control}
        defaultValue={file?.name || ""}
        render={({ field }) => (
          <TextField
            {...field}
            label={file?.name}
            fullWidth
            inputProps={{ maxLength: 100 }}
            error={!!errors?.files?.[index]?.title}
            helperText={errors?.files?.[index]?.title?.message || ""}
          />
        )}
      />
      <CategoriesPicker index={index} categories={categories} />
    </Stack>
  );
}

function CategoriesPicker({ index, categories }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();

  if (categories.isLoading) {
    return <CircularProgress />;
  } else if (categories.error) {
    return (
      <SimpleAlert
        severity={"error"}
        message={"FailedToFetchDocumentCategoryList"}
      />
    );
  } else if (categories.translatedCategories.length == 0) {
    return null;
  }
  
  return (
    <Controller
      name={`files[${index}].category`}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <FormControl fullWidth error={!!errors?.files?.[index]?.category}>
          <InputLabel>{t("Category")}</InputLabel>
          <Select {...field} label={t("Category")} sx={{ mt: "3px" }}>
            {categories?.translatedCategories?.map((category) => (
              <MenuItem value={category?.id} key={category?.id}>
                {category?.title}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>
            {errors?.files?.[index]?.category?.message || ""}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
}
